import React, { useEffect, useState } from 'react';


interface TagInputProps {
  label: string;
  tags: string[]; // Prop para recibir el arreglo de etiquetas
  onTagsChange: (tags: string[]) => void; // Prop para manejar el cambio de etiquetas
}



const TagInput: React.FC<TagInputProps> = ({ label, tags, onTagsChange }) => {

  const [currentTags, setCurrentTags] = useState<string[]>(tags);
  const [inputValue, setInputValue] = useState('');

  // Actualiza el estado de las etiquetas cuando la prop `tags` cambie
  useEffect(() => {
    setCurrentTags(tags);
  }, [tags]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && inputValue.trim()) {
      e.preventDefault();
      if (!currentTags.includes(inputValue)) {
        const newTags = [...currentTags, inputValue];
        setCurrentTags(newTags);
        setInputValue('');
        onTagsChange(newTags); // Notifica al componente padre del cambio
      }
    }
  };

  const removeTag = (tagToRemove: string) => {
    const newTags = currentTags.filter(tag => tag !== tagToRemove);
    setCurrentTags(newTags);
    onTagsChange(newTags); // Notifica al componente padre del cambio
  };

  return (
    <div className="mb-3">
      <label className="form-label">{label}</label>
      <div className="tag-input-container">
        <div className='selected-tags'>
          {currentTags.map((tag, index) => (
            <span key={index} className="tag">
              {tag}
              <button
                type="button"
                className="remove-tag-btn"
                onClick={() => removeTag(tag)}
              >
                &times;
              </button>
            </span>
          ))}
        </div>




        <input
          type="text"
          className="tag-input-field rounded-0"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Add a tag"
        />
      </div>
    </div>
  );
};

export default TagInput;
